import React from 'react';
import bn from '../utils/bemnames';

interface IProps {
  height: number;
  heightMobile: number;
  isMobile: boolean;
}

const bem = bn.create('loading-block');
const LoadingBlock: React.FC<IProps> = ({ height, heightMobile, isMobile}) => (
  <div
    className={bem.e('wrp')}
    style={{'height': isMobile ? heightMobile : height + 'px'}}
  />
);

export default LoadingBlock;
